import ModalVideo from './ModalVideo';

export default ModalVideo;
